/**
 * @generated SignedSource<<4bef9f0cab2aca688763f538dae37c6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type seatHistoryChart_Query$variables = {
  pseudonym: string;
};
export type seatHistoryChart_Query$data = {
  readonly customerSeatHistory: {
    readonly available: boolean;
    readonly changed: boolean;
    readonly currentSeats: number | null | undefined;
    readonly maxSeats: number | null | undefined;
    readonly minSeats: number | null | undefined;
    readonly points: ReadonlyArray<{
      readonly month: string;
      readonly observed: boolean;
      readonly plan: string | null | undefined;
      readonly seats: number;
    }>;
    readonly pseudonym: string;
  };
};
export type seatHistoryChart_Query = {
  response: seatHistoryChart_Query$data;
  variables: seatHistoryChart_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pseudonym"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pseudonym",
        "variableName": "pseudonym"
      }
    ],
    "concreteType": "CustomerSeatHistory",
    "kind": "LinkedField",
    "name": "customerSeatHistory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pseudonym",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "available",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minSeats",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxSeats",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentSeats",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SeatPoint",
        "kind": "LinkedField",
        "name": "points",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "observed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plan",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "seatHistoryChart_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "seatHistoryChart_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e03a2ac1a9b3fc79fdd1a1796434c1f2",
    "id": null,
    "metadata": {},
    "name": "seatHistoryChart_Query",
    "operationKind": "query",
    "text": "query seatHistoryChart_Query(\n  $pseudonym: String!\n) {\n  customerSeatHistory(pseudonym: $pseudonym) {\n    pseudonym\n    available\n    changed\n    minSeats\n    maxSeats\n    currentSeats\n    points {\n      month\n      seats\n      observed\n      plan\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e984f69ed71d5fb16ef4597f99701210";

export default node;
